import { createI18n, useI18n } from "vue-i18n";


import tw from '@/core/config/i18n/tw.json'
import en from '@/core/config/i18n/en.json'
import ja from '@/core/config/i18n/ja.json'
import cn from '@/core/config/i18n/cn.json'

let browserLanguage = window.navigator.language

// 先塞入瀏覽器預設語言在 i18n
//console.log(browserLanguage)
if (browserLanguage.toLowerCase() === 'zh-tw') {
  browserLanguage = 'tw'
} else {
  browserLanguage = 'en'
}
//console.log(browserLanguage)
const messages = {
  en: en,
  tw: tw,
  ja: ja,
  cn: cn
};

const i18n = createI18n({
  legacy: false,
  locale: browserLanguage,
  globalInjection: true,
  messages
});

export { i18n };
